import { createUseStyles } from 'react-jss'
import { useExcel } from '../../redux/slices/excel'
import ExcelProgress from './ExcelProgress'

const useStyles = createUseStyles({
  container: {
    position: 'fixed',
    bottom: '4px',
    left: '0px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 1000,
  },
  downloadBox: {
    background: '#1C1C1C',
    padding: '20px 40px',
    width: '400px',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgb(28 28 28 / 75%)',
  },
})

function PatientsExcel() {
  const classes = useStyles()
  const excelProgress = useExcel() // Figure better naming in general, ask for ideas.
  const archiveIds = Object.keys(excelProgress)

  if (archiveIds.length === 0) return null

  return (
    <div className={classes.container}>
      <div className={classes.downloadBox}>
        {archiveIds.map(key => {
          const { progress } = excelProgress[key]

          return <ExcelProgress key={key} progress={progress} archiveId={key} />
        })}
      </div>
    </div>
  )
}

export default PatientsExcel
